<template>
	<BaseCmsPage v-slot="{page}">
	<Body class="auth-lr auth-l" />
		<AuthLoginRegisterLayout>
			<h1 style="display: none;" v-if="page?.seo_h1">{{ page?.seo_h1 }}</h1>
			<template #col1>
				<AuthLoginForm mode="login" />
			</template>
			<template #col2>
				<div v-if="page?.content" class="cms-content" v-html="wrapInnerBtn(page.content)" v-interpolation />
			</template>
		</AuthLoginRegisterLayout>
	</BaseCmsPage>
</template>